/**
 * @module Experince/Search-Results
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
// @TODO: Rename model once we have API number defined

// Interfaces
import { SEARCH_RESULT_CONSTANTS } from '@experience/search-results/constant/search-result-constant';
import { FilterOptionsSelected, SortOptions } from '@support/api/common/product.interface';

// Models
import { Query } from '@experience/search-results/model/query.model';

export class SearchRequestPayload {
  private billingType: string;
  private creditLevels: string[];
  private customerId: string;
  private accountId: string;
  private filtersRequested: string[];
  private filterOptionsSelected: FilterOptionsSelected[];
  private postalCode: string;
  private storeId: string;
  private sortOptions: SortOptions[];
  private pageSize: string;
  private pageNumber: string;
  private filterValuePath: string;

  constructor(
    queryModel: Query,
    filtersRequested: string[],
    filterOptionsSelected?: FilterOptionsSelected[],
    selectedsortOptionValue?: string,
    billingType?: string,
    filterSelectedPath?: string
  ) {
    this.billingType = '';
    this.creditLevels = [];
    this.customerId = '';
    this.accountId = '';
    this.postalCode = '';
    this.storeId = '';
    this.pageSize = queryModel.getPageSize();
    this.pageNumber = queryModel.getPageNumber();
    this.filterValuePath = filterSelectedPath ? filterSelectedPath : '';
    this.filterOptionsSelected = filterOptionsSelected;
    this.filtersRequested = filtersRequested;
    this.sortOptions = [
      {
        sortDirection: SEARCH_RESULT_CONSTANTS.ASCENDING,
        sortOptionValue: selectedsortOptionValue,
      },
    ];
  }
}
